import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    backgroundColor: theme?.waitList?.backgroundColor,
    height: '100vh',
  },
  listContainer: {
    height: '87vh',
    overflowY: 'scroll',
  },
  headerBox: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  button: {
    marginLeft: theme.spacing(1.5),
    textTransform: 'none',
    backgroundColor: theme?.waitList?.primaryButtonBackgroundColor,
    color: theme?.waitList?.primaryButtonTextColor,
    "&:hover": {
      backgroundColor: theme?.waitList?.primaryButtonBackgroundColor,
    },
  },
  iconButton: {
    color: theme?.waitList?.iconColor,
    padding: 0,
  },
  rightAlign: {
    position: 'absolute',
    right: 0,
  },
  dragEnabled: {
    color: theme?.waitList?.borderColor,
  },
  dragButton: {
    padding: theme.spacing(0.8),
    borderRadius: theme.spacing(0.5),
    backgroundColor: theme?.waitList?.actionButtonBackgroundColor,
    "&:hover": {
      backgroundColor: theme?.waitList?.actionButtonBackgroundColor,
    }
  },
  buttonsBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonGrpBtn: {
    textTransform: 'none',
    color: theme?.waitList?.textColor,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme?.waitList?.secondaryButtonBorderColor,
    "&:hover": {
      borderColor: theme?.waitList?.secondaryButtonBackgroundColor
    }
  },
  selectButtonGrp: {
    backgroundColor: theme?.waitList?.secondaryButtonBackgroundColor,
    color: theme?.waitList?.secondaryButtonTextColor,
    "&:hover": {
      backgroundColor: theme?.waitList?.secondaryButtonBackgroundColor,
    }
  },
  listPaper: {
    backgroundColor: theme?.waitList?.cardBackgroundColor,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
  },
  commonActionBtn: {
    color: theme?.waitList?.iconColor,
    padding: 0,
    backgroundColor: theme?.waitList?.actionButtonBackgroundColor,
    borderRadius: theme.spacing(0.5),
    marginLeft: theme.spacing(0.4),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: theme?.waitList?.primaryButtonBackgroundColor,
    },
  },
  actionBtn: {
    height: 28,
    width: 28,
  },
  noteBtn: {
    height: 28,
    width: 28,
    backgroundColor: 'transparent',
    color: theme?.waitList?.noteIconColor,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  partySizeBtn: {
    height: 45,
    width: 35,
    backgroundColor: theme?.waitList?.partySizeBackgroundColor,
  },
  sendBtn: {
    backgroundColor: theme?.waitList?.primaryButtonBackgroundColor,
    height: 45,
    width: 40,
  },
  text: {
    color: theme?.waitList?.textColor,
    fontWeight: 400,
  },
  notesWrapper: {
    backgroundColor: theme?.waitList?.notesBackgroundColor,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderRadius: theme.spacing(0.5),
    marginTop: theme.spacing(0.5),
  },
}));

export default useStyles;
